import styled, { withTheme } from 'styled-components';
import { useContext, useEffect, useState } from 'react';
import RestaurantContext from '../../Context/RestaurantContext';
import { Row, Col, Container } from 'react-bootstrap';
import CartContext from '../../Context/CartContext';
import Currency from '/util/Currency.js';
import Icon from '../Icon';
import { useMediaQuery } from 'react-responsive';

const Wrapper = styled.div`
  @media (min-width: 992px) {
    display: none;
  }

  position: fixed;
  z-index: 98;

  bottom: ${(props) => (props.$show ? 0 : 'calc(-56px - (env(safe-area-inset-bottom) / 2))')};
  transition: bottom 100ms;
  left: 0;
  right: 0;
  height: calc(56px + (env(safe-area-inset-bottom) / 2));
  padding-bottom: ${(props) => (props.$show ? 'env(safe-area-inset-bottom / 2)' : 0)};

  background-color: ${(props) => props.theme.colors.primary};
`;

const ContentWrapper = styled.div`
  display: flex;
  height: 56px;

  color: #ffffff;

  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.85px;
`;

const CartIconWrapper = styled.div`
  position: relative;
  height: 34px;

  #cart {
    height: 100%;
  }

  @media (min-width: 768px) {
  }
`;

const CartAmountWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: 12px;
    font-weight: 500;
  }
`;

const CartStripMobile = (props) => {
  const { setShowCartModal } = useContext(RestaurantContext);
  const {
    cart: {
      meta: { totalPrice, items },
    },
  } = useContext(CartContext);

  const isCartAlwaysVisibleInScreen = useMediaQuery({
    query: '(min-width: 992px)',
  });

  const [isOnClient, setIsOnClient] = useState(false);
  useEffect(() => {
    setIsOnClient(true);
  }, []);

  return (
    <>
      {isCartAlwaysVisibleInScreen || !isOnClient ? null : (
        <Wrapper onClick={() => setShowCartModal(true)} $show={items > 0}>
          <ContentWrapper>
            <Container style={{ display: 'flex', alignItems: 'center' }}>
              <Row style={{ flexGrow: 1 }}>
                <Col xs={5} style={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}>
                  &nbsp;
                </Col>
                <Col xs={2} style={{ textAlign: 'center' }}>
                  <CartIconWrapper>
                    <Icon
                      name="cart"
                      id="cart"
                      style={{
                        fill: '#ffffff',
                      }}
                    />
                    <CartAmountWrapper>
                      <span>{items}</span>
                    </CartAmountWrapper>
                  </CartIconWrapper>
                </Col>
                <Col
                  xs={5}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    textAlign: 'right',
                  }}
                >
                  <Currency as="span">{totalPrice}</Currency>
                </Col>
              </Row>
            </Container>
          </ContentWrapper>
        </Wrapper>
      )}
    </>
  );
};

export default withTheme(CartStripMobile);
